import { useMemo } from 'react';
import { useTabWorkspaceLayout } from '../layout/public-api';

export type OperationalFilterVariant = 'mobile' | 'wide' | 'workspace';

/** Segmentos y labels compactos en pantallas muy angostas (Informes, POS búsqueda). */
export const OPERATIONAL_FILTER_COMPACT_BREAKPOINT = 400;

export type OperationalFilterLayout = {
  width: number;
  layoutWide: boolean;
  layoutWebShell: boolean;
  variant: OperationalFilterVariant;
  isMobile: boolean;
  searchCompact: boolean;
};

/**
 * Layout unificado para paneles de filtro operativos (Customer, POS, Catálogo, Stock, Informes).
 *
 * - mobile: ancho &lt; 768 — segmentos apilados, pickers en fila completa.
 * - wide: 768+ — chips y `wideToolbarRow` para pickers maestros.
 * - workspace: web con sidebar @960 — secciones con label + divider (master-detail).
 */
export function useOperationalFilterLayout(): OperationalFilterLayout {
  const { width, layoutWide, layoutWebShell } = useTabWorkspaceLayout();
  return useMemo(() => {
    const variant: OperationalFilterVariant = layoutWebShell
      ? 'workspace'
      : layoutWide
        ? 'wide'
        : 'mobile';
    return {
      width,
      layoutWide,
      layoutWebShell,
      variant,
      isMobile: variant === 'mobile',
      searchCompact: width < OPERATIONAL_FILTER_COMPACT_BREAKPOINT,
    };
  }, [width, layoutWide, layoutWebShell]);
}
